const common = require('./checklist_items_common')
const getSpotlight = require('module/user/helpers/get_spotlight')
const log = require('log').create('get started', 'pro') // eslint-disable-line

/**
 * checklist items for pro users
 *
 * the order here determines the priority of each item, which comes into play
 * when evaluating what their 'next' step is
 *
 * the display order is controlled by the html markup in
 * checklist_view_pro.html
 */

const pro_checklist_items = [

    common.add_custom_domain,

    {
        id: 'setup_byod_domain',
        applicable() {
            // only applicable to users with byod domains
            const domain = this.user.get('domain')
            if (! domain) return false
            return ! domain.get('purchase')
        },
        completed() {
            const domain = this.user.get('domain')
            if (! domain) return false
            if (domain.get('purchase')) return true
            return new Promise(resolve => {
                domain.verifyDnsIfNeeded(() => {
                    resolve(domain.get('dns').isValid())
                })
            })
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('dns_settings')
        },
    },

    {
        id: 'update_email_signature',
        completed() {
            return this.user.hasAction('clicked_signature_cta_pro')
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('emailsignature')
        },
    },

    common.verify_email,

    {
        id: 'add_pro_spotlight',
        completed() {
            const spotlight = getSpotlight(this.user.toJSON())
            if (spotlight && spotlight.is_premium) return true
            return this.user.hasAction('viewed_spotlight_from_pro_checklist')
        },
        onClick(e) {
            e.preventDefault()
            this.user.trackAction('viewed_spotlight_from_pro_checklist')
            this.showSection('spotlight')
        },
    },

    common.add_portfolio_or_video,

    {
        id: 'add_bio',
        applicable() {
            return ! this.user.hasFeature('bio')
        },
        completed() {
            return this.user.hasFeature('bio')
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('bio')
        },
    },

    common.link_social_sites,

]

module.exports = pro_checklist_items
